module.exports = __webpack_public_path__ + "img/inner_4_3.936c190d.png";